export default __webpack_public_path__ + "static/media/Allocate-documentation.65aef60e.md";